<script>
import { mapGetters } from "vuex";
import HorizontalStackedBarChart from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.vue";
import DashboardSpinner from "@/components/modules/new-dashboard/components/dashboard-spinner.vue";
import DashboardNoData from "@/components/modules/new-dashboard/components/dashboard-no-data.vue";

export default {
  name: "EmployeesByOrganizationSize",
  components: {DashboardNoData, DashboardSpinner, HorizontalStackedBarChart },
  data() {
    return {
      colors: {
        optionList_selfAssessment_general_size_numberEmployees_large: "#19A39C",
        optionList_selfAssessment_general_size_numberEmployees_medium: "#F32474",
        optionList_selfAssessment_general_size_numberEmployees_small: "#B7C51C",
        optionList_selfAssessment_general_size_numberEmployees_micro: "#22C2E5"
      },
      groups: [
        "optionList_selfAssessment_general_size_numberEmployees_large",
        "optionList_selfAssessment_general_size_numberEmployees_medium",
        "optionList_selfAssessment_general_size_numberEmployees_small",
        "optionList_selfAssessment_general_size_numberEmployees_micro",
      ],
      config: {
        width: 400,
        height: 220,
        marginTop: 0,
        marginBottom: 0,
        axisLabelSpacePercentage:30,
      },
      employeesByOrganizationSize:[]
    };
  },
  computed: mapGetters(["getEmployeesByOrganizationSize"]),
  mounted() {
    this.formatEmployeesByOrganizationSize()
  },
  watch: {
    'getEmployeesByOrganizationSize.data': {
 handler:     function() {
        this.formatEmployeesByOrganizationSize()
      }
    },deep:true
  },
  methods: {
    formatEmployeesByOrganizationSize: function () {
      this.employeesByOrganizationSize= this.getEmployeesByOrganizationSize.data.filter(empl=>!!empl._id).map(employees => {
        return {
          group: employees._id,
          subGroup: employees._id,
          value: employees.count,
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <dashboard-spinner :height="220" v-if="getEmployeesByOrganizationSize.loading"></dashboard-spinner>
    <dashboard-no-data :height="220" v-if="!getEmployeesByOrganizationSize.loading && !employeesByOrganizationSize.length"></dashboard-no-data>
    <horizontal-stacked-bar-chart
      v-if="employeesByOrganizationSize.length && !getEmployeesByOrganizationSize.loading"
      :chart-data="employeesByOrganizationSize"
      :colors="colors"
      :custom-group-sorting="groups"
      :config="config"
      :parent-height="false"
    >
    </horizontal-stacked-bar-chart>
  </div>
</template>

<style scoped lang="scss">

</style>
